"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchPerspectiveReferenceDirection = exports.extractPerspectiveDatabases = exports.createPerspectiveConfig = exports.createPerspectiveNodeConfig = void 0;
const v1_1 = __importDefault(require("uuid/v1"));
function createPerspectiveNodeConfig(name) {
    const node = {
        pureName: name.pureName,
        schemaName: name.schemaName,
        designerId: (0, v1_1.default)(),
        expandedColumns: [],
        checkedColumns: [],
        columnDisplays: {},
        sort: [],
        filters: {},
        isNodeChecked: true,
    };
    return node;
}
exports.createPerspectiveNodeConfig = createPerspectiveNodeConfig;
function createPerspectiveConfig(rootObject) {
    if (!rootObject) {
        return {
            nodes: [],
            references: [],
            isArranged: true,
            rootDesignerId: null,
        };
    }
    const rootNode = createPerspectiveNodeConfig(rootObject);
    return {
        nodes: [rootNode],
        references: [],
        rootDesignerId: rootNode.designerId,
        isArranged: true,
    };
}
exports.createPerspectiveConfig = createPerspectiveConfig;
function extractPerspectiveDatabases({ conid, database }, cfg) {
    const res = [];
    res.push({ conid, database });
    function add(conid, database) {
        if (res.find(x => x.conid == conid && x.database == database))
            return;
        res.push({ conid, database });
    }
    for (const node of cfg.nodes) {
        add(node.conid || conid, node.database || database);
    }
    return res;
}
exports.extractPerspectiveDatabases = extractPerspectiveDatabases;
function switchPerspectiveReferenceDirection(ref) {
    return {
        designerId: ref.designerId,
        sourceId: ref.targetId,
        targetId: ref.sourceId,
        isAutoGenerated: ref.isAutoGenerated,
        columns: ref.columns.map(x => ({ source: x.target, target: x.source })),
    };
}
exports.switchPerspectiveReferenceDirection = switchPerspectiveReferenceDirection;
